import { parsePositiveInteger } from '../pub-admin/logic';

export { parsePositiveInteger };

export type AllocationMode = 'allocate' | 'recall';

/** 배분은 양수, 회수는 음수로 서버에 보낸다. */
export function toSignedAmount(mode: AllocationMode, value: number): number {
  return mode === 'allocate' ? value : -value;
}

export interface AllocationPreview {
  franchiseBalance: number;
  storeBalance: number;
  error: string | null;
}

/** 배분/회수 후 잔액을 미리 계산한다. 서버도 같은 규칙으로 다시 검증한다. */
export function previewAllocation(
  franchiseBalance: number,
  storeBalance: number,
  mode: AllocationMode,
  amount: number,
): AllocationPreview {
  const signed = toSignedAmount(mode, amount);
  const nextFranchise = franchiseBalance - signed;
  const nextStore = storeBalance + signed;
  let error: string | null = null;
  if (nextFranchise < 0) error = '본사 OC 잔액이 부족합니다.';
  else if (nextStore < 0) error = '회수할 매장 OC 잔액이 부족합니다.';
  return { franchiseBalance: nextFranchise, storeBalance: nextStore, error };
}

/** 선택 입력인 결제 금액(원). 비어 있으면 null, 0 이상의 정수가 아니면 undefined. */
export function parseOptionalKrw(value: string): number | null | undefined {
  const normalized = value.replace(/[,\s]/g, '');
  if (normalized === '') return null;
  if (!/^\d+$/.test(normalized)) return undefined;
  const parsed = Number(normalized);
  return Number.isSafeInteger(parsed) ? parsed : undefined;
}
